export default __webpack_public_path__ + "static/media/wordpress-filled.44c8ea9f.svg";